// @ts-ignore
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient, useIsRestoring } from "@tanstack/react-query";

export const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      // cacheTime: 1000 * 60 * 60 * 24, // 24 hours,
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
    },
  },
});

export const reactQueryPersister = createSyncStoragePersister({
  storage: window.localStorage,
});

export function ReactQueryPersistGate({ children }: any) {
  const isRestoring = useIsRestoring();
  return isRestoring ? null : children;
}
